// src/services/emoji.js — the emoji a status can start with, in groups.
//
// 🟥 THE STATUS EDITOR OFFERED THIRTY, IN A STRIP BESIDE THE FIELD. Thirty is
//    enough to prove the feature works and not enough for anybody to find the
//    one they meant, and a strip that wraps to four rows beside a text box is
//    both cramped and in the way of the thing it decorates. The browser has room
//    the phone does not; this is the list that uses it.
//
// 🟢 GROUPED, BECAUSE A FLAT GRID OF FOUR HUNDRED IS A WALL. The groups are the
//    ones every emoji keyboard uses, in the order they use them, so the bottom
//    bar is a thing people already know how to read rather than a taxonomy of
//    ours. Each group's `icon` is one of its own members — a label made of the
//    thing it labels needs no translating.
//
// 🟥 NOTHING HERE IS NEWER THAN UNICODE 12 (2019). A picker is a promise that
//    what you pick will be drawn, and a recent codepoint renders as a hollow box
//    on an OS that has not caught up — worse than not offering it, because the
//    box is what the other person sees too.
//
// 🟢 AND THE PHONE'S THIRTY ARE A SUBSET OF THESE. A status set in a browser and
//    the same status reopened on a phone have to look identical; the phone's
//    shorter list is a smaller keyboard, not a different alphabet.

export const EMOJI_GROUPS = [
  {
    id: 'smileys',
    name: 'Smileys & people',
    icon: '😀',
    emojis: [
      '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃',
      '😉', '😊', '😇', '🥰', '😍', '🤩', '😘', '😗', '😚', '😙',
      '😋', '😛', '😜', '🤪', '😝', '🤗', '🤭', '🤫', '🤔', '🤐',
      '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '😌', '😔', '😪',
      '🤤', '😴', '😷', '🤒', '🤕', '🤢', '🤧', '🥵', '🥶', '😵',
      '🤯', '🤠', '🥳', '😎', '🤓', '🧐', '😕', '😟', '🙁', '😮',
      '😯', '😲', '😳', '🥺', '😦', '😧', '😨', '😰', '😥', '😢',
      '😭', '😱', '😖', '😣', '😞', '😓', '😩', '😫', '😤', '😡',
      '😠', '🤬', '👿', '💀', '💩', '🤡', '👻', '👽', '🤖', '🎃',
      '👋', '🤚', '✋', '👌', '✌️', '🤞', '🤟', '🤘', '👈', '👉',
      '👆', '👇', '👍', '👎', '✊', '👊', '👏', '🙌', '🙏', '💪',
      '🧠', '👀', '👶', '🧒', '👦', '👧', '🧑', '👨', '👩', '🧓',
    ],
  },
  {
    id: 'nature',
    name: 'Animals & nature',
    icon: '🐶',
    emojis: [
      '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯',
      '🦁', '🐮', '🐷', '🐸', '🐵', '🙈', '🙉', '🙊', '🐔', '🐧',
      '🐦', '🐤', '🦆', '🦅', '🦉', '🦇', '🐺', '🐗', '🐴', '🦄',
      '🐝', '🐛', '🦋', '🐌', '🐞', '🐜', '🕷️', '🐢', '🐍', '🦎',
      '🐙', '🦑', '🦐', '🦀', '🐡', '🐠', '🐟', '🐬', '🐳', '🐋',
      '🦈', '🐊', '🐅', '🦓', '🦍', '🐘', '🦏', '🐪', '🦒', '🐃',
      '🐑', '🐐', '🦌', '🐕', '🐩', '🐈', '🐓', '🦃', '🕊️', '🐇',
      '🌵', '🎄', '🌲', '🌳', '🌴', '🌱', '🌿', '☘️', '🍀', '🎍',
      '🍂', '🍁', '🍄', '🌾', '💐', '🌷', '🌹', '🥀', '🌺', '🌸',
      '🌼', '🌻', '🌞', '🌝', '🌛', '🌜', '🌚', '🌕', '🌙', '⭐',
      '🌟', '✨', '⚡', '🔥', '💥', '☄️', '☀️', '🌤️', '⛅', '🌧️',
      '⛈️', '🌩️', '🌨️', '❄️', '☃️', '⛄', '🌬️', '💨', '🌪️', '🌈',
    ],
  },
  {
    id: 'food',
    name: 'Food & drink',
    icon: '🍕',
    emojis: [
      '🍏', '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🍈',
      '🍒', '🍑', '🥭', '🍍', '🥥', '🥝', '🍅', '🥑', '🍆', '🥔',
      '🥕', '🌽', '🌶️', '🥒', '🥬', '🥦', '🧄', '🧅', '🍄', '🥜',
      '🌰', '🍞', '🥐', '🥖', '🥨', '🥯', '🥞', '🧇', '🧀', '🍖',
      '🍗', '🥩', '🥓', '🍔', '🍟', '🍕', '🌭', '🥪', '🌮', '🌯',
      '🥙', '🧆', '🥚', '🍳', '🥘', '🍲', '🥣', '🥗', '🍿', '🧈',
      '🧂', '🥫', '🍱', '🍘', '🍙', '🍚', '🍛', '🍜', '🍝', '🍠',
      '🍢', '🍣', '🍤', '🍥', '🥮', '🍡', '🥟', '🍦', '🍧', '🍨',
      '🍩', '🍪', '🎂', '🍰', '🧁', '🥧', '🍫', '🍬', '🍭', '🍮',
      '🍯', '🍼', '🥛', '☕', '🍵', '🧃', '🥤', '🍶', '🍺', '🍻',
      '🥂', '🍷', '🥃', '🍸', '🍹', '🧉', '🧊', '🥢', '🍽️', '🍴',
    ],
  },
  {
    id: 'activity',
    name: 'Activities',
    icon: '⚽',
    emojis: [
      '⚽', '🏀', '🏈', '⚾', '🥎', '🎾', '🏐', '🏉', '🥏', '🎱',
      '🏓', '🏸', '🥅', '🏒', '🏑', '🥍', '🏏', '⛳', '🏹', '🎣',
      '🥊', '🥋', '🎽', '🛹', '🛷', '⛸️', '🥌', '🎿', '⛷️', '🏂',
      '🏋️', '🤼', '🤸', '⛹️', '🤺', '🤾', '🏌️', '🏇', '🧘', '🏄',
      '🏊', '🤽', '🚣', '🧗', '🚵', '🚴', '🏆', '🥇', '🥈', '🥉',
      '🏅', '🎖️', '🎗️', '🎫', '🎟️', '🎪', '🤹', '🎭', '🎨', '🎬',
      '🎤', '🎧', '🎼', '🎹', '🥁', '🎷', '🎺', '🎸', '🪕', '🎻',
      '🎲', '♟️', '🎯', '🎳', '🎮', '🕹️', '🎰', '🧩', '🎉', '🎊',
      '🎈', '🎁', '🎀', '🪄', '🧨', '✨', '🎇', '🎆', '🏮', '🎐',
    ],
  },
  {
    id: 'travel',
    name: 'Travel & places',
    icon: '✈️',
    emojis: [
      '🚗', '🚕', '🚙', '🚌', '🚎', '🏎️', '🚓', '🚑', '🚒', '🚐',
      '🚚', '🚛', '🚜', '🛴', '🚲', '🛵', '🏍️', '🛺', '🚨', '🚔',
      '🚍', '🚘', '🚖', '🚡', '🚠', '🚟', '🚃', '🚋', '🚞', '🚝',
      '🚄', '🚅', '🚈', '🚂', '🚆', '🚇', '🚊', '🚉', '✈️', '🛫',
      '🛬', '🛩️', '💺', '🛰️', '🚀', '🛸', '🚁', '🛶', '⛵', '🚤',
      '🛥️', '🛳️', '⛴️', '🚢', '⚓', '⛽', '🚧', '🚦', '🚥', '🗺️',
      '🗿', '🗽', '🗼', '🏰', '🏯', '🏟️', '🎡', '🎢', '🎠', '⛲',
      '⛱️', '🏖️', '🏝️', '🏜️', '🌋', '⛰️', '🏔️', '🗻', '🏕️', '⛺',
      '🏠', '🏡', '🏘️', '🏚️', '🏗️', '🏭', '🏢', '🏬', '🏣', '🏤',
      '🏥', '🏦', '🏨', '🏪', '🏫', '🏩', '💒', '🏛️', '⛪', '🕌',
      '🕍', '🛕', '🕋', '⛩️', '🌁', '🌃', '🏙️', '🌄', '🌅', '🌆',
      '🌇', '🌉', '🌌', '🎑', '🗾', '🌍', '🌎', '🌏', '🧭', '🕰️',
    ],
  },
  {
    id: 'objects',
    name: 'Objects',
    icon: '💡',
    emojis: [
      '⌚', '📱', '💻', '⌨️', '🖥️', '🖨️', '🖱️', '💽', '💾', '💿',
      '📀', '📷', '📸', '📹', '🎥', '📽️', '📞', '☎️', '📟', '📠',
      '📺', '📻', '🎙️', '⏱️', '⏲️', '⏰', '⌛', '⏳', '📡', '🔋',
      '🔌', '💡', '🔦', '🕯️', '🧯', '🛢️', '💸', '💵', '💴', '💶',
      '💷', '💰', '💳', '💎', '⚖️', '🧰', '🔧', '🔨', '⚒️', '🛠️',
      '⛏️', '🔩', '⚙️', '🧱', '⛓️', '🧲', '🔫', '💣', '🧪', '🧬',
      '🔬', '🔭', '📿', '💊', '💉', '🩹', '🩺', '🚪', '🛏️', '🛋️',
      '🚽', '🚿', '🛁', '🧴', '🧷', '🧹', '🧺', '🧻', '🧼', '🧽',
      '🔑', '🗝️', '🔒', '🔓', '📦', '📫', '📮', '✉️', '📨', '📩',
      '📤', '📥', '📃', '📄', '📑', '📊', '📈', '📉', '🗒️', '📆',
      '📅', '📇', '🗃️', '🗄️', '📋', '📌', '📎', '✂️', '📐', '📏',
      '🖊️', '🖋️', '✒️', '🖌️', '🖍️', '📝', '✏️', '🔍', '🔎', '📚',
    ],
  },
  {
    id: 'symbols',
    name: 'Symbols',
    icon: '❤️',
    emojis: [
      '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔',
      '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '☮️',
      '✝️', '☪️', '🕉️', '☸️', '✡️', '🔯', '🕎', '☯️', '☦️', '🛐',
      '♈', '♉', '♊', '♋', '♌', '♍', '♎', '♏', '♐', '♑',
      '♒', '♓', '🆔', '⚛️', '🉑', '☢️', '☣️', '📴', '📳', '🈶',
      '🈚', '🈸', '🈺', '🈷️', '✴️', '🆚', '💮', '🉐', '㊙️', '㊗️',
      '🈴', '🈵', '🈹', '🈲', '🅰️', '🅱️', '🆎', '🆑', '🅾️', '🆘',
      '❌', '⭕', '🛑', '⛔', '📛', '🚫', '💯', '💢', '♨️', '🚷',
      '✅', '☑️', '✔️', '❇️', '✳️', '❎', '🌐', '💠', 'Ⓜ️', '🌀',
      '💤', '🏧', '🚾', '♿', '🅿️', '🈳', '🈂️', '🛂', '🛃', '🛄',
      '🛅', '🚹', '🚺', '🚼', '⚠️', '🚸', '🔱', '⚜️', '🔰', '♻️',
      '🔁', '❗', '❓', '❕', '❔', '‼️', '⁉️', '🔅', '🔆', '〽️',
      /* 🟥 THE COLOURED SHAPES EARN THEIR PLACE: 🟢 is the first of the five
         preset statuses both clients offer, so a picker without it cannot
         reproduce a status the product itself suggests. */
      '🟢', '🔴', '🟠', '🟡', '🔵', '🟣', '🟤', '⚫', '⚪', '🔶',
      '🔷', '🔸', '🔹', '🔺', '🔻', '▪️', '▫️', '◼️', '◻️', '⬛',
    ],
  },
  {
    id: 'flags',
    name: 'Flags',
    icon: '🏳️',
    emojis: [
      '🏁', '🚩', '🎌', '🏴', '🏳️', '🏳️‍🌈', '🇸🇦', '🇮🇶', '🇦🇪', '🇰🇼',
      '🇧🇭', '🇶🇦', '🇴🇲', '🇯🇴', '🇱🇧', '🇸🇾', '🇾🇪', '🇪🇬', '🇲🇦', '🇩🇿',
      '🇹🇳', '🇱🇾', '🇸🇩', '🇸🇴', '🇹🇷', '🇮🇷', '🇵🇰', '🇮🇳', '🇧🇩', '🇱🇰',
      '🇳🇵', '🇨🇳', '🇯🇵', '🇰🇷', '🇹🇼', '🇭🇰', '🇸🇬', '🇲🇾', '🇮🇩', '🇹🇭',
      '🇻🇳', '🇵🇭', '🇦🇺', '🇳🇿', '🇺🇸', '🇨🇦', '🇲🇽', '🇧🇷', '🇦🇷', '🇨🇱',
      '🇨🇴', '🇵🇪', '🇬🇧', '🇮🇪', '🇫🇷', '🇩🇪', '🇮🇹', '🇪🇸', '🇵🇹', '🇳🇱',
      '🇧🇪', '🇨🇭', '🇦🇹', '🇸🇪', '🇳🇴', '🇩🇰', '🇫🇮', '🇮🇸', '🇵🇱', '🇨🇿',
      '🇸🇰', '🇭🇺', '🇷🇴', '🇧🇬', '🇬🇷', '🇷🇺', '🇺🇦', '🇷🇸', '🇭🇷', '🇺🇿',
      '🇰🇿', '🇦🇿', '🇬🇪', '🇦🇲', '🇮🇱', '🇿🇦', '🇳🇬', '🇰🇪', '🇪🇹', '🇬🇭',
    ],
  },
];

/** Every emoji the picker offers, flattened — one list, one definition. */
export function allEmojis() {
  return EMOJI_GROUPS.flatMap((g) => g.emojis);
}

/**
 * The group an emoji belongs to, or ''.
 *
 * 🟢 USED TO REOPEN THE PICKER WHERE THE CURRENT STATUS LEFT IT. Landing on
 *    Smileys when the status starts with a flag means scrolling to find what is
 *    already chosen, which is the one thing the user definitely does not need to
 *    look for.
 */
export function groupOf(emoji) {
  const e = String(emoji || '');
  if (!e) return '';
  const g = EMOJI_GROUPS.find((x) => x.emojis.includes(e));
  return g ? g.id : '';
}
